import { defineStyleConfig } from "@chakra-ui/react";
export const Link = defineStyleConfig({
    baseStyle: {
        _focus: {
            // TODO: handle accessibility properly
            boxShadow: "none",
        },
    },
});
//# sourceMappingURL=Link.js.map